import type { Node, NodeProps } from '@xyflow/react';
import type React from 'react';
import { memo } from 'react';
import BaseContainerNode, { type BaseContainerNodeData } from './base-container-node.component';
import { mitigatingControlsContainerId } from './container-node-ids';

type MitigatingControlsContainerNodeData = BaseContainerNodeData;
export type MitigatingControlsContainerNodeType = Node<MitigatingControlsContainerNodeData>;
type MitigatingControlsContainerNodeProps = NodeProps<MitigatingControlsContainerNodeType>;

const label = 'Mitigating Controls';
const className = 'border-mc-border bg-mc-bg text-mc-fg';
const data = { label, className };

/**
 * A React functional component that renders a container node for Mitigating Controls.
 *
 * This component is a wrapper around the `BaseContainerNode` and passes
 * all received props along with additional data to it.
 *
 * @component
 * @param {MitigatingControlsContainerNodeProps} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered container node component.
 *
 * @example
 * ```tsx
 * <MitigatingControlsContainerNode />
 * ```
 */
const MitigatingControlsContainerNode = (props: MitigatingControlsContainerNodeProps): React.JSX.Element => {
  return <BaseContainerNode {...props} id={mitigatingControlsContainerId} data={data} />;
};

export default memo(MitigatingControlsContainerNode);
